import React, { useEffect } from 'react';
import { Card, Slider } from 'antd';

const Question = ({ result, question, onChange }) => {
  const { title, type, value } = result;

  useEffect(() => {
    if (!value) onChange([0, 10]);
  }, [value]);

  return (
    <Card>
      <p>Title: {title}</p>
      <p>Type: {type}</p>
      <Slider
        range
        defaultValue={[0, 10]}
        tooltipVisible
        min={0}
        max={10}
        step={1}
        value={value || [0, 10]}
        onChange={onChange}
      />
    </Card>
  );
};

export default Question;
